/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DiscountType {
  PERCENT = 'percent',
  FIXED = 'fixed',
}
